import { Box, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import { ChangeEvent, useMemo } from 'react'
import TokTokDocDialog from '../../../Common/Dialog'
import { SuccessCheckIcon } from 'apps/ids/src/app/assets/icons/icons'
import CloseIcon from '@mui/icons-material/Close'
import CancelIcon from '@mui/icons-material/Cancel'
import useStyles from './_styles'
import { DialogRenameProps } from './_props'
import { checkInvalidChars, invalidCharsError, RENAME_DIALOG_MAX_LENGTH } from './_utils'

export default function DialogRename({
    open,
    title,
    value,
    onClose,
    onChangeValue,
    onConfirm,
    isConfirmDisabled,
}: DialogRenameProps) {
    const classes = useStyles()

    const error = useMemo(() => (checkInvalidChars(value) ? invalidCharsError : null), [value])

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (e.target.value.length <= RENAME_DIALOG_MAX_LENGTH) {
            onChangeValue(e.target.value)
        }
    }

    const handleClear = () => {
        onChangeValue('')
    }

    return (
        <TokTokDocDialog
            isOpen={open}
            handleClose={onClose}
            handleSave={onConfirm}
            handleCancel={onClose}
            saveTitle="Renommer"
            cancelTitle="Annuler"
            title={title}
            loading={false}
            disableEscape={false}
            disableCondition={isConfirmDisabled || error !== null}
            dialogProps={{
                fullScreen: false,
                disableScrollLock: false,
                PaperProps: {
                    className: classes.dialogPaperNoScroll,
                    style: { overflow: 'hidden' },
                },
            }}
            classNames={{
                dialogTitle: classes.helpDraftTitle,
                paper: classes.helpDialogPaper,
            }}
            buttonsOptions={{
                colors: {
                    save: '#313336',
                    cancel: undefined,
                },
            }}
        >
            <Box className={classes.dialogFieldGroup}>
                <Box className={`${classes.dialogLabelRow} ${error ? classes.dialogLabelRowError : ''}`}>
                    <Typography className={value ? classes.dialogFieldLabelActive : classes.dialogFieldLabel}>
                        Nouveau nom du fichier
                    </Typography>
                    {(value || error) &&
                        (error ? <CancelIcon className={classes.dialogErrorIcon} /> : <SuccessCheckIcon />)}
                </Box>
                <TextField
                    autoFocus
                    fullWidth
                    placeholder="Saisir un nom de fichier"
                    value={value}
                    onChange={handleChange}
                    error={!!error}
                    helperText={error}
                    FormHelperTextProps={{ className: classes.dialogHelperText }}
                    className={`${classes.dialogTextField} ${error ? classes.dialogTextFieldError : ''}`}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end" sx={{ display: value.length > 0 ? 'flex' : 'none' }}>
                                <IconButton onClick={handleClear} sx={{ padding: 0 }}>
                                    <CloseIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    inputProps={{ maxLength: RENAME_DIALOG_MAX_LENGTH }}
                />
                {!error && (
                    <Box className={classes.charLimitRow}>
                        <Typography className={classes.charLimitText}>
                            Maximum {RENAME_DIALOG_MAX_LENGTH} caractères acceptés :
                        </Typography>
                        <Typography className={classes.charLimitText}>
                            {value.length}/{RENAME_DIALOG_MAX_LENGTH}
                        </Typography>
                    </Box>
                )}
            </Box>
        </TokTokDocDialog>
    )
}
